import {Navigate, useNavigate} from "react-router-dom";

import Cookies from "js-cookie";
import MainPage from "./Pages/MainPage";
import {ReactComponent as MainIcon} from './Asset/images/icons/homeicon.svg';
import {ReactComponent as Exiticon} from './Asset/images/icons/exiticon.svg';
import LoginPage from "./Pages/LoginPage/LoginPage";
import RegisterPage from "./Pages/RegisterPage";
import StudentInformation from "./Pages/Student/InformationPage/indes";
import SalamatStudent from "./Pages/Student/SalamatPage";
import LifeStyleStudent from "./Pages/Student/LifestylePage";
import FroumPage from "./Pages/FroumPage";
import NoskhePage from "./Pages/NoskhePage";
import StudentInfoPage from "./Pages/StudentInfoPage";
import Instructional from "./Pages/InstructionalPage";
import UsersPage from "./Pages/UsersPage";
import StudentLandingPage from "./Pages/Student/LandingPage";
import StudentPersonal from "./Pages/Student/StudentPersonal";
import StudentAmoozshi from "./Pages/Student/StudentAmoozshi";
import StudentForum from "./Pages/Student/StudentForum";
import StudentNoskhe from "./Pages/Student/StudentNoskhe";


export const Page404 = () => {
    return (
        <>
            <div style={{padding: 20}}>Nots Found</div>
        </>
    );
};

function LogoutPage() {
    const navigate = useNavigate();
    Cookies.remove('ut');
    Cookies.remove('cst');
    navigate("/login", {replace: true})
    return null;
}

const routes = () => {
    return [
        {
            type: "component",
            name: "صفحه اصلی",
            key: "",
            route: "/",
            component: <MainPage/>,
            level: "public"
            // level: ["SabtKonande", "Nazer", "Modir", "Admin"],
        },
        {
            type: "component",
            name: "دانش آموز",
            key: "studentlanding",
            route: "/studentlanding",
            component: <StudentLandingPage/>,
            level: "public"
            // level: ["SabtKonande", "Nazer", "Modir", "Admin"],
        },
        {
            type: "component",
            name: "تالار گفتگو دانش آموز",
            key: "studentforum",
            route: "/studentforum",
            component: <StudentForum/>,
            level: "public"
            // level: ["SabtKonande", "Nazer", "Modir", "Admin"],
        }, 
        {
            type: "component",
            name: "نسخه پزشک دانش آموز",
            key: "studentnoskhe",
            route: "/studentnoskhe",
            component: <StudentNoskhe/>,
            level: "public"
            // level: ["SabtKonande", "Nazer", "Modir", "Admin"],
        },
        {
            type: "component",
            name: "اطلاعات دانش آموز",
            key: "studentpersonal",
            route: "/studentpersonal",
            component: <StudentPersonal/>,
            level: "public"
            // level: ["SabtKonande", "Nazer", "Modir", "Admin"],
        },
        {
            type: "component",
            name: "مطالب اموزشی دانش اموز",
            key: "StudentAmoozshi",
            route: "/StudentAmoozshi",
            component: <StudentAmoozshi/>,
            level: "public"
            // level: ["SabtKonande", "Nazer", "Modir", "Admin"],
        },
        {
            type: "component",
            name: "ورود",
            key: "login",
            route: "/login",
            component: <LoginPage/>,
            level: "sign",
        },
        {
            type: "component",
            name: "ثبت نام",
            key: "register",
            route: "/register",
            component: <RegisterPage/>,
            level: "sign",
        },
        {
            type: "collapse",
            name: "اطلاعات فردی",
            key: "information",
            route: "/information",
            img: require("./Asset/images/pinformation.png"),

            component: <StudentInformation/>,
            level: ["Student", "Pezeshk", "Morabi", "Parent"],
        },
        {
            type: "collapse",
            name: "کاربران",
            key: "users",
            route: "/users",
            img: require("./Asset/images/pinformation.png"),

            component: <UsersPage/>,
            level: ["Admin"],
        },
        {
            type: "collapse",
            name: "اطلاعات سلامت",
            key: "studentsalamat",
            route: "/studentsalamat",
            img: require("./Asset/images/ned2.png"),

            component: <SalamatStudent/>,
            level: ["Student"],
        }, {
            type: "collapse",
            name: "اطلاعات سبک زندگی",
            key: "lifestyle",
            route: "/lifestyle",
            img: require("./Asset/images/ned3.png"),
            component: <LifeStyleStudent/>,
            level: ["Student"],
        },
        {
            type: "collapse",
            name: "اطلاعات‌دانش‌آموزان",
            key: "studentinfo",
            route: "/studentinfo",
            img: require("./Asset/images/g55.png"),

            component: <StudentInfoPage/>,
            level: ["Pezeshk", "Morabi", "Parent", "Admin"],
        },
        {
            type: "collapse",
            name: "مطالب آموزشی ",
            key: "instructional",
            route: "/instructional",
            img: require("./Asset/images/ned3.png"),

            component: <Instructional/>,
            level: ["Student", "Pezeshk", "Admin"],
        },
        {
            type: "collapse",
            name: "تالار گفتگو",
            key: "froum",
                route: "/froum",
            img: require("./Asset/images/ned4.png"),

            component: <FroumPage/>,
            level: ["Student", "Pezeshk", "Morabi", "Parent", "Admin"],
        },
        {
            type: "collapse",
            name: "نسخه پزشک",
            key: "noskhe",
            route: "/noskhe",
            img: require("./Asset/images/ned5.png"),

            component: <NoskhePage/>,
            level: ["Student",],
        },
        // {
        //     type: "collapse",
        //     name: "ثبت هیسترکتومی",
        //     key: "sabtclient",
        //     route: "/sabtclient",
        //     component: <Navigate to={"/client"} replace/>,
        //     icon: <SabtIcon/>,
        //     level: ["SabtKonande", "Admin"],
        // },
        // {
        //     type: "collapse",
        //     name: "افزودن کاربر",
        //     key: "adduser",
        //     route: "/adduser",
        //     component: <AddUser/>,
        //     icon: <Addicon/>,
        //     level: "Admin",
        // },
        // {
        //     type: "collapse",
        //     name: "لیست کاربران",
        //     key: "userlist",
        //     route: "/userlist",
        //     component: <ListUser/>,
        //     icon: <Listkarbaricon/>,
        //     level: "Admin",
        // },
        // {
        //     type: "collapse",
        //     name: "لیست پیام ها",
        //     key: "message",
        //     route: "/message",
        //     component: <Message/>,
        //     icon: <PayamList/>,
        //     level: ["SabtKonande", "Nazer", "Modir", "Admin"],
        // },
        // {
        //     type: "collapse",
        //     name: "اطلاعات پایه",
        //     key: "baseinformation",
        //     route: "/baseinformation",
        //     component: <BaseInformation/>,
        //     icon: <SettingsApplicationsIcon/>,
        //     level: ["Admin"],
        // },
        // {
        //     type: "collapse",
        //     name: "گزارشات",
        //     key: "statistics",
        //     route: "/statistics",
        //     component: <Statistics/>,
        //     icon: <ListAltIcon/>,
        //     level: ["SabtKonande", "Nazer", "Modir", "Admin"],
        // },
        // {
        //     type: "kist",
        //     name: "چت",
        //     key: "chat",
        //     route: "/chat",
        //     component: <Chat/>,
        //     icon: <ListAltIcon/>,
        //     level: ["SabtKonande", "Nazer", "Modir", "Admin"],
        // },
        // {
        //     type: "kist",
        //     name: "چت",
        //     key: "chatidd",
        //     route: "/chat/:id",
        //     component: <ChatId/>,
        //     icon: <ListAltIcon/>,
        //     level: ["Admin", "nazer"],
        // },
        // {
        //     type: "kist",
        //     key: "edituser",
        //     route: "/adduser/:id",
        //     component: <AddUser/>,
        //     icon: <ListAltIcon/>,
        //     level: "Admin",
        // },
        // {
        //     type: "kist",
        //     key: "gozareshbastary",
        //     route: "/gozareshbastary",
        //     component: <GozareshBastary/>,
        //     icon: <ListAltIcon/>,
        //     level: "Admin",
        // }, {
        //     type: "kist",

        //     key: "gozareshavarez",
        //     route: "/gozareshavarez",
        //     component: <GozareshAvarez/>,
        //     icon: <ListAltIcon/>,
        //     level: "Admin",
        // },

        // {
        //     type: "component",
        //     name: "notfound",
        //     key: "notfound",
        //     route: "/notfound",
        //     component: <Page404/>,
        //     level: "Admin",
        // },

        // {
        //     type: "form",
        //     name: "اطلاعات دموگرافیک",
        //     key: "Client",
        //     route: "/client/:id?",
        //     component: <Client/>,
        //     level: "auth",
        // },
        // {
        //     type: "form",
        //     name: "اطلاعات سابقه بیمار",
        //     key: "History",
        //     route: "/history/:id",
        //     component: <History/>,
        //     level: "auth",
        // },
        // {
        //     type: "form",
        //     name: "اطلاعات پروفیلاکسی",
        //     key: "Profilaxy",
        //     route: "/pofilaxy/:id",
        //     component: <Profilaxy/>,
        //     level: "auth",
        // },
        // {
        //     type: "form",
        //     name: "اطلاعات عمل جراحی",
        //     key: "Surgery",
        //     route: "/surgery/:id",
        //     component: <Surgery/>,
        //     level: "auth",
        // },
        // {
        //     type: "form",
        //     name: "مداخلات",
        //     key: "Modakhelat",
        //     route: "/modakhelat/:id",
        //     component: <Modakhelat/>,
        //     level: "auth",
        // },
        // {
        //     type: "form",
        //     name: "اطلاعات   عوارض بستری",
        //     key: "Avarez",
        //     route: "/avarez/:id",
        //     component: <Avarez/>,
        //     level: "auth",
        // },
        // {
        //     type: "form",
        //     name: "اطلاعات ترخیص",
        //     key: "Tarkhis",
        //     route: "/tarkhis/:id",
        //     component: <Tarkhis/>,
        //     level: "auth",
        // },

        // {
        //     type: "form",
        //     name: "اطلاعات پاتولوژی",
        //     key: "Patology",
        //     route: "/patology/:id",
        //     component: <Patology/>,
        //     level: "auth",
        // },

        // {
        //     type: "form",
        //     name: "بستری مجدد",
        //     key: "BastaryMojadad",
        //     route: "/bastaryMojadad/:id",
        //     component: <BastaryMojadad/>,
        //     level: "auth",
        // },
        // {
        //     type: "component",
        //     name: "notfound",
        //     key: "VorohHisto",
        //     route: "*",
        //     component: <Navigate to={"/"} replace/>,
        //     // level: "auth",
        // },
        // {
        //     type: "component",
        //     name: "notfound",
        //     key: "navtomain",
        //     route: "/navtomain",
        //     component: <Navigate to={"/"} replace/>,
        //     // level: "auth",
        // },
        {
            type: "collapse",
            name: "خروج",
            key: "Exit",
            route: "/logout",
            component: <LogoutPage/>,
            img: require("./Asset/images/exiticon.png"),
            level: ["Pezeshk", "Student", "Parent", "Morabi", "Admin"],
        },
    ]
}
export default routes;
